export const getTabToShow = () => {
    return window && window.settings && window.settings.features && window.settings.features.tabsLimit ? window.settings.features.tabsLimit : 4;
}

export const addCssDynamically = () => {
    return window && window.settings && window.settings.features && window.settings.features.enablePWA ? document.querySelector('style').textContent += "@media screen and (max-width:767px) { .modules { margin-bottom: 50px; } #fc_frame, #fc_frame.fc-widget-normal { bottom: 60px !important; }" : ""
}

export const getPrimaryColor = () => {
    return window && window.settings && window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary && window.settings.brand.cta.primary.backgroundColor || "#ffffff"
}

export const getPrimaryNavigation = () => {
    return window && window.settings && window.settings.navigation && window.settings.navigation.primary || []
}
